 <template>
  <div class="sidebar" v-if="siderbarList.length > 0">
    <swiper ref="mySwiper" :options="swiperOption" class="swiper_right">
      <div
        class="swiper-slide"
        v-for="(item, index) in siderbarList"
        @click="menuToJump('trace' + index, index)"
        :key="index"
      >
        <img v-show="index != menuIndex" src="@/assets/images/bar.png" alt="" />
        <img
          v-show="index == menuIndex"
          src="@/assets/images/bar-active.png"
          alt=""
        />
        <span class="text"> {{ item.name | getFourTxt }}</span>
      </div>
    </swiper>
  </div>
</template> 

<script>
export default {
  filters: {
    getFourTxt(str) {
      return (str = str.length > 4 ? str.substring(0, 4) : str);
    },
  },
  watch: {
    "$store.state.menuIndex": {
      handler(val) {
        console.log("变化");
        console.log(val);
        if (val > this.siderbarList.length - 1) {
          val = this.siderbarList.length - 1;
        }
        this.menuIndex = val;
        this.slideNext(val);
      },
    },
  },
  data() {
    return {
      // siderbarList: [],
      siderbarList: [
        // {
        //   name: "种植信息",
        //   path: "/plantInfo",
        // },
        // {
        //   name: "加工信息",
        //   path: "/processInfo",
        // },
      ],
      defalutSlider: [
        {
          name: "防伪信息",
          path: "/anti-fake?defaultId=1",
          defaultId: 1,
        },
        {
          name: "商品信息",
          path: "/tem?defaultId=2",
          defaultId: 2,
        },
        {
          name: "企业信息",
          path: "/enterprise?defaultId=3",
          defaultId: 3,
        },
        {
          name: "流通信息",
          path: "/Tradeinfo?defaultId=4",
          defaultId: 4,
        },
        {
          name: "质检信息",
          path: "/qualityTesting?defaultId=5",
          defaultId: 5,
        },
        {
          name: "智能监测",
          path: "/intelligent?defaultId=7",
          defaultId: 7,
        },
      ],
      menuIndex: 0,
      swiperOption: {
        // loop: true,
        // speed: oriSpeed,
        slidesPerView: "auto",
        freeMode: true,
        direction: "vertical",
        setWrapperSize: true,
        on: {
          slideChangeTransitionStart: function () {
            console.log(this.activeIndex);
          },
        },
        // autoplayDisableOnInteraction: false,
      },
    };
  },
  async created() {
    // 根据id绑定菜单跳转
    console.log(this.$route);
    // let lockInfo = {
    //   1: "/goodsInfo?id=0",
    //   2: "/securityInfo?id=2",
    //   3: "/enterpriseInfo?id=3",
    //   4: "/qsInfo?id=4",
    //   5: "/circulationInfo?id=5",
    // };
    // 如果是undefind 就默认交转plantInfo 代表是自定义环节
    // plantInfo
    // let localArr = JSON.parse(window.localStorage.getItem("idInObj") || "[]");
    let params = this.$route.query;
    if (params.defaultId) {
      if (!params.id) {
        return;
      }
      const { data: re } = await this.$api.getDataApi(
        params.id,
        params.batch_code,
        params.merchant_id,
        params.t
      );
      if (re.code === 200) {
        
        let defalutArr = JSON.parse(re.data).data_list;
        console.log('sid', defalutArr);
        let listsTg = JSON.parse(re.data).lists;
        console.log('sid', listsTg);

        // 将推广信息按钮配置存储在本地
        if (listsTg) {
          localStorage.setItem("lists", JSON.stringify(listsTg));
        }
        defalutArr.forEach((element) => {
          if (isNaN(Number(element.trace_id))) {
            //代表自定义环节
            this.siderbarList.push({
              name: element.trace_name,
              path: `/plantInfo?defaultId=${element.trace_id}`,
              defaultId: element.trace_id,
            });
          }
        });
      }
    } else {
      let defalutArr = JSON.parse(
        window.localStorage.getItem("defalutObj") || "[]"
      );
      //先进行排序
      let indexYL = defalutArr.findIndex((v) => {
        return v.trace_id == "0";
      });
      if (indexYL != -1) {
        //删除原料环节--原料环节不显示  只提供所需数据
        defalutArr.splice(indexYL, 1);
      }

      defalutArr = defalutArr.sort((a, b) => {
        return a.sort - b.sort;
      });

      window.localStorage.setItem("defalutObj", JSON.stringify(defalutArr));
      console.log(defalutArr);
      let slider_ContentList = [];
      defalutArr.forEach((element) => {
        if (isNaN(Number(element.trace_id))) {
          this.siderbarList.push({
            name: element.trace_name,
            path: `/plantInfo?defaultId=${element.trace_id}`,
            defaultId: element.trace_id,
            sort: element.sort,
          });
          slider_ContentList.push(element);
        } else {
          //匹配默认环节
          let traceDefalut = this.defalutSlider.filter((v) => {
            return v.name == element.trace_name;
          });
          if (traceDefalut.length) {
            this.siderbarList.push({
              name: element.trace_name,
              path: traceDefalut[0].path,
              defaultId: traceDefalut[0].defaultId,
              sort: element.sort,
            });
            slider_ContentList.push(element);
          }
        }
      });
      console.log(this.siderbarList);
      window.localStorage.setItem(
        "slierBarListContent",
        JSON.stringify(slider_ContentList)
      );
      // this.$router.push(this.siderbarList[0].path);
    }

    //遍历出自定义环节
    // this.siderbarList = lockInfo;

    // let sliderArr = [];
    // defalutArr.forEach((element) => {
    //   // 如果id为0 证明是原料 不参与页面标题栏循环 除id为0外 其他可以进行push到菜单栏数组
    //   if (element.trace_id != 0) {
    //     // 进入此判断只有两种情况 1.lockinfo匹配到了固定模板路径  2.为undefined。继续判断是否为undefiend  是=>为自定义模板路径
    //     sliderArr.push({
    //       path: lockInfo[element.trace_id]
    //         ? `${lockInfo[element.trace_id]}?id=${element.trace_id}`
    //         : `/plantInfo?id=${element.trace_id}`,
    //       id: element.trace_id,
    //       trace_name: element.trace_name,
    //     });
    //   }
    // });
    // this.siderbarList = sliderArr;
    // console.log(this.siderbarList)
    // console.log(sliderArr);
  },
  methods: {
    handleBarChange(v) {
      this.$router.push(v.path);
    },
    slideNext(index) {
      this.$refs.mySwiper.swiper.slideTo(index);
    },
    menuToJump(id, index) {
      this.$bus.$emit("menuSetBus", id);
      this.$store.commit("isClickMeunHandle", true);
      this.menuIndex = index;
      setTimeout(() => {
        this.$store.commit("isClickMeunHandle", false);
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar {
  .siderbar-item {
    width: 80px;
    height: 208px;
    position: relative;
    img {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 20px;
      display: inline-block;
      width: 28px;
      font-size: 28px;
      font-family: PingFang SC;
      line-height: 32px;
      color: #11745f;
      word-break: break-all;
    }
  }
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  width: 80px;
  height: 208px;
  position: relative;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  // -ms-flex-align: center;
  // -webkit-align-items: center;
  // align-items: center;
  img {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .text {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
    display: inline-block;
    width: 28px;
    font-size: 28px;
    font-family: PingFang SC;
    line-height: 32px;
    color: #11745f;
    word-break: break-all;
  }
}
.swiper_right {
  height: calc(100vh - 88px);
}
</style> --> -->
